<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-title"><strong><a href="#/OEBPS/toc#p02">PART TWO:</a></strong></h1>
<p class="line"><img alt="" src="OEBPS/images/line.jpg"/></p>
<p class="part-subtitle"><strong><a href="#/OEBPS/toc#p02">1509</a></strong></p>
<p class="nonindent">He cherished justice above all things; as a result he vigorously punished violence, manslaughter and every other kind of wickedness whatsoever. Consequently he was greatly regretted on that account by all his subjects, who had been able to conduct their lives peaceably, far removed from the assaults and evil doing of scoundrels. He was the most ardent supporter of our faith, and daily participated with great piety in religious services … But all these virtues were obscured latterly by avarice, from which he suffered. This avarice is surely a bad enough vice in a private individual, whom it forever torments; in a monarch indeed it may be considered the worst vice since it is harmful to everyone, and distorts those qualities of trustfulness, justice and integrity by which the State must be governed.</p>
<p class="right">Polydore Vergil on Henry VII<span href="#/OEBPS/enote#p02-sec1_ftn1" id="p02-sec1_fn1" title="Link target outside of Sample"><sup>1</sup></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p02.vue?23648a5d